import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CrearNotaDeCreditoEdit } from "./edit";
import { FiltroFacturas } from "app/models/requireme";

export type Entity = number;
export interface Props extends kea.ModalProps<Entity, boolean, FiltroFacturas> {
}


/**
* Modal para crear un contrarecibo
*/
export class GenerarNotaDeCreditoModalEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;

    errorSeleccion = (props: Props) => props.value == null;

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        return (
            <kea.Modal
                buttons={[<kea.Button children="Generar" style="primary" onClick={this.onGuardar} disabled={this.errorSeleccion(this.props)} />]}
                onClose={this.onCerrar}
                title="Seleccionar factura para nota de crédito"
                fullScreen
            >
                <CrearNotaDeCreditoEdit value={value} filtro= {this.props.params} onChange={this.props.onChange} />
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/notacredito/generarnotasdecredito/modal.tsx